import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import apiClient from "@/api/client";
import imageOne from "../../resource/talks/ourteacher/inside/2.png";
import imageThree from "../../resource/talks/ourteacher/inside/3.png";
import imageTwo from "../../resource/talks/ourteacher/inside/4.png";
import imageSeven from "../../resource/talks/ourteacher/inside/5.png";
import imageFour from "../../resource/talks/ourteacher/inside/6.png";
import banner from "../../resource/talks/ourteacher/inside/7.jpeg";
import TitleChnage from "../../Hook/TitleChnage";

const DammaTalksPage = () => {
  TitleChnage("Our Teacher");

  const navigate = useNavigate();
  
  // Search state
  const [searchFilters, setSearchFilters] = useState({
    sutta_title: '',
    event_title: '',
    retreat_no: '',
    event_location: '',
    event_start_date: '',
    event_end_date: ''
  });
  
  const [searchResults, setSearchResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const [allSuttas, setAllSuttas] = useState([]);

  // Fetch all suttas on component mount for search functionality
  useEffect(() => {
    fetchAllSuttas();
  }, []);

  const fetchAllSuttas = async () => {
    try {
        const response = await apiClient.get('/dhamma-talks');
        setAllSuttas(response.data.data || response.data);
    } catch (error) {
        console.error('Error fetching suttas:', error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSearchFilters(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSearch = async () => {
    setIsSearching(true);
    setHasSearched(true);

    try {
      // Filter results based on search criteria
      const filteredResults = allSuttas.filter(sutta => {
        // Check if any field matches (case-insensitive)
        const suttaTitleMatch = !searchFilters.sutta_title || 
          sutta.sutta_title?.toLowerCase().includes(searchFilters.sutta_title.toLowerCase());
        
        const eventTitleMatch = !searchFilters.event_title || 
          sutta.event_title?.toLowerCase().includes(searchFilters.event_title.toLowerCase());
        
        const retreatNoMatch = !searchFilters.retreat_no || 
          sutta.retreat_no?.toLowerCase().includes(searchFilters.retreat_no.toLowerCase());
        
        const locationMatch = !searchFilters.event_location || 
          sutta.event_location?.toLowerCase().includes(searchFilters.event_location.toLowerCase());
        
        // Date matching
        const startDateMatch = !searchFilters.event_start_date || 
          (sutta.event_start_date && sutta.event_start_date.split('T')[0] >= searchFilters.event_start_date);
        
        const endDateMatch = !searchFilters.event_end_date || 
          (sutta.event_end_date && sutta.event_end_date.split('T')[0] <= searchFilters.event_end_date);

        // Return true if ALL filled criteria match
        return suttaTitleMatch && eventTitleMatch && retreatNoMatch && 
               locationMatch && startDateMatch && endDateMatch;
      });

      setSearchResults(filteredResults);
    } catch (error) {
      console.error('Search error:', error);
      setSearchResults([]);
    } finally {
      setIsSearching(false);
    }
  };

  const handleClear = () => {
    setSearchFilters({
      sutta_title: '',
      event_title: '',
      retreat_no: '',
      event_location: '',
      event_start_date: '',
      event_end_date: ''
    });
    setSearchResults([]);
    setHasSearched(false);
  };

  const handleClick = (event) => {
    const pathMap = {
      dammaTalksPage: "/dammaTalksPage",
    };

    const path = event.currentTarget.id;
    const targetPath = pathMap[path];

    if (targetPath) {
      navigate(targetPath);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  const getTypeIcon = (type) => {
    switch (type) {
      case 'audio': return '🎵';
      case 'video': return '🎥';
      case 'document': return '📄';
      default: return '🔗';
    }
  };

  return (
    <div className="dmmatalkteahcer-page inside-pages">
      <div className="right-box">
        <img
          src={imageOne}
          alt="Right Top Image"
          className="right-image"
          width={300}
        />
      </div>

      <h1 className="font-main p-4 mt-4">Dhamma Talks</h1>

      <p className="h4 mt-5 p-4">
        Current and previous Dhamma Sermons delivered by the Senior Abbot of
        Bhaddeka Vihari Monastery and Meditation Center, Most Venerable
        Wagadapola Wimalaghana Thero.
      </p>

      <img src={banner} className="mt-5" alt="" style={{ width: "100%" }} />

      <p className="h4 mt-5 p-4">
        If you know the details of the Dhamma sermon or the Retreat of interest,
        please use the following search buttons to refine your criteria.
      </p>

      {/* Search Form */}
      <div className="form-box mt-5 p-4">
        <p className="h4">Sutta Name (Title)</p>
        <div className="form-item">
          <input 
            type="text" 
            name="sutta_title"
            value={searchFilters.sutta_title}
            onChange={handleInputChange}
            placeholder="Enter sutta title..."
          />
        </div>
      </div>

      <div className="form-box mt-5 p-4">
        <p className="h4">Event Title</p>
        <div className="form-item">
          <input 
            type="text" 
            name="event_title"
            value={searchFilters.event_title}
            onChange={handleInputChange}
            placeholder="Enter event title..."
          />
        </div>
      </div>

      <div className="form-box mt-5 p-4">
        <p className="h4">Retreat No (Event No)</p>
        <div className="form-item">
          <input 
            type="text" 
            name="retreat_no"
            value={searchFilters.retreat_no}
            onChange={handleInputChange}
            placeholder="e.g., RET2024-001"
          />
        </div>
      </div>

      <div className="form-box mt-5 p-4">
        <p className="h4">Event Location</p>
        <div className="form-item">
          <input 
            type="text" 
            name="event_location"
            value={searchFilters.event_location}
            onChange={handleInputChange}
            placeholder="Enter event location..."
          />
        </div>
      </div>

      <div className="form-box mt-5 p-4">
        <p className="h4">Event Start Date</p>
        <div className="form-item">
          <input 
            type="date" 
            name="event_start_date"
            value={searchFilters.event_start_date}
            onChange={handleInputChange}
          />
        </div>
      </div>

      <div className="form-box mt-5 p-4">
        <p className="h4">Event End Date</p>
        <div className="form-item">
          <input 
            type="date" 
            name="event_end_date"
            value={searchFilters.event_end_date}
            onChange={handleInputChange}
          />
        </div>
      </div>

      <div className="formbtn p-4 mt-5">
        <button type="button" onClick={handleClear}>CLEAR</button>
        <button 
          type="button" 
          onClick={handleSearch}
          disabled={isSearching}
        >
          {isSearching ? 'SEARCHING...' : 'SEARCH'}
        </button>
      </div>

      {/* Search Results Section */}
      {hasSearched && (
        <div className="search-results mt-5 p-4">
          <div style={{ 
              
            borderRadius: '2px', 
            padding: '20px',
            margin: '20px 0'
          }}>
            <h3 className="h4 mb-4">
              Search Results ({searchResults.length} found)
            </h3>
            
            {searchResults.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
                <p className="h5">No Dhamma talks found matching your criteria.</p>
                <p>Try adjusting your search filters or clearing them to see all talks.</p>
              </div>
            ) : (
              <div className="results-grid">
                {searchResults.map((sutta, index) => (
                  <div key={sutta.id || index} style={{
                    backgroundColor: '#f9f9f9ff',
                    border: '1px solid #e0e0e0',
                    borderRadius: '2px',
                    padding: '20px',
                    marginBottom: '20px',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                  }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '15px' }}>
                      <h4 style={{ color: '#8B4513', marginBottom: '5px', fontSize: '1.2em' }}>
                        {sutta.sutta_title}
                      </h4>
                      <span style={{
                        backgroundColor: '#8B4513',
                        color: 'white',
                        padding: '4px 8px',
                        borderRadius: '12px',
                        fontSize: '0.8em',
                        fontWeight: 'bold'
                      }}>
                        {sutta.retreat_no}
                      </span>
                    </div>
                    
                    <p style={{ fontSize: '1.1em', marginBottom: '10px', fontWeight: '500' }}>
                      {sutta.event_title}
                    </p>
                    
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '10px', marginBottom: '15px' }}>
                      <div>
                        <strong>📍 Location:</strong> {sutta.event_location}
                      </div>
                      <div>
                        <strong>📅 Duration:</strong> {formatDate(sutta.event_start_date)} - {formatDate(sutta.event_end_date)}
                      </div>
                    </div>

                    {/* Resources/Links */}
                    {sutta.links && sutta.links.length > 0 && (
                      <div style={{ marginTop: '15px' }}>
                        <strong style={{ display: 'block', marginBottom: '8px' }}>📚 Resources:</strong>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                          {sutta.links.map((link, linkIndex) => (
                            <a
                              key={linkIndex}
                              href={link.url}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '5px',
                                padding: '6px 12px',
                                backgroundColor: '#f0f8ff',
                                border: '1px solid #87ceeb',
                                borderRadius: '20px',
                                textDecoration: 'none',
                                color: '#4682b4',
                                fontSize: '0.9em',
                                transition: 'background-color 0.3s'
                              }}
                              onMouseOver={(e) => e.target.style.backgroundColor = '#e6f3ff'}
                              onMouseOut={(e) => e.target.style.backgroundColor = '#f0f8ff'}
                            >
                              <span>{getTypeIcon(link.type)}</span>
                              {link.title}
                            </a>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}

      <p className="h4 mt-5 p-4">
        Alternatively, you may choose from the following three categories to
        explore a comprehensive list of events or individual events delivered by
        the Most Venerable Wagadapola Wimalaghana Thero, at Bhaddeka Vihari
        Monastery.
      </p>

      <div className="btn-group3 mt-6">
        <img
          src={imageTwo}
          alt="Right Top Image"
          width={300}
          className="curser-pointer"
          id="internalRules"
        />
        <img
          src={imageSeven}
          alt="Right Top Image"
          width={300}
          className="curser-pointer"
          id="internalRetreatForm"
        />
        <img
          src={imageFour}
          alt="Right Top Image"
          width={300}
          className="curser-pointer"
          id="internalRetreatForm"
        />
      </div>

      <p className="font-second mt-6 p-4 text-center">"Sunatha Dharetha Charatha Dhamme"</p>
      <p className="h4 mt-5 p-4 text-center">Listen deeply, maintain its wisdom, and practice its path</p>

      <div className="bottom-box mt-6">
        <img src={imageThree} alt="bottom-image" width={600} />
      </div>
    </div>
  );
};

export default DammaTalksPage;